import gql from "graphql-tag";

export default gql`
  fragment PostOrReplyAuthorFields on User {
    _id
    email
    firstName
    lastName
    fullName
    pictureUrl
    isSiteAdmin
  }
`;
